import { cn } from "@workspace/ui/lib/utils";
import Collection from "~/components/blocks/collection-grid";
import Faq from "~/components/blocks/faq";
import { HeroBanner } from "~/components/blocks/hero-banner";
import ImageTileCta from "~/components/blocks/image-tile-cta";
import InstagramFeed from "~/components/blocks/instagram-feed";
import StoreInfo from "~/components/blocks/store-info";
import { Testimonials } from "~/components/blocks/testimonials";
import Text from "~/components/blocks/text";
import type { DataForLandingPage } from "~/routes/storefront/products/splat";
import {
	type LandingBlockTagged,
	toTaggedBlock,
} from "~/utils/helpers/block-tagger";

export default function Page({ data }: { data: DataForLandingPage }) {
	const { blocks, storeInfo, feed } = data;

	const tagged = blocks
		.map(toTaggedBlock)
		.filter((x): x is LandingBlockTagged => x !== null);

	return (
		<div
			className={cn(
				"mt-8 flex min-h-screen flex-col",
			)}
		>
			<div className="flex flex-1 flex-col gap-8 md:gap-10">
				{tagged.map((block: LandingBlockTagged, index: number) => {
					const key = `${block.kind}-${index}`;
					switch (block.kind) {
						case "banner":
							return <HeroBanner key={key} {...block.data} />;
						case "imageTileCta":
							return <ImageTileCta key={key} {...block.data} />;
						case "collectionGrid":
							return <Collection key={key} {...block.data} />;
						case "faq":
							return <Faq key={key} {...block.data} />;
						case "testimonials":
							return <Testimonials key={key} {...block.data} />;
						case "text":
							return <Text key={key} {...block.data} />;
						case "storeinfo":
							return <StoreInfo key={key} storeInfo={storeInfo} />;
						case "instagramFeed":
							return feed ? <InstagramFeed key={key} feed={feed} /> : null;
						default:
							return null;
					}
				})}
			</div>
		</div>
	);
}
